import { h, render } from "vue";
import SaveToCollectionChooser from "%/dynamic-component-editor/components/saved-posts/SaveToCollectionChooser.vue";

export function mountSaveChooser(appContext) {
  const host = document.createElement("div");
  host.dataset.saveChooserHost = "";
  document.body.appendChild(host);
  const chooser = h(SaveToCollectionChooser);
  chooser.appContext = appContext;
  render(chooser, host);
  return () => {
    render(null, host);
    host.remove();
  };
}
